import Index from "./page/index/index.vue";
export default {
  computed: {
    isSubPage: function isSubPage() {
      return this.$store.state.isSubPage;
    }
  },
  mounted: function mounted() {
    if (/(QQLive|WeTV)(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/i.test(navigator.userAgent) && TenvideoJSBridge) {
      TenvideoJSBridge.on('onActionLogoutFinish', function () {
        location.reload();
      });
      TenvideoJSBridge.on('onActionLoginFinish', function () {
        location.reload();
      });
    }
  },
  components: {
    Index: Index,
    SubPage: function SubPage() {
      return import("./page/subPage/subPage.vue");
    }
  }
};